// extracted by mini-css-extract-plugin
export var standaloneTable = "_gb-0";
export var standaloneTableWithBodyFill = "_gb-1";
export var withExtraHeader = "_gb-2";